const STYLE_ID = "label-print-style";
export const PRINT_ROOT_ID = "label-print-root";

/**
 * Déclenche l'impression du conteneur `#label-print-root`.
 *
 * Injecte une feuille de style temporaire qui :
 *  - fixe la taille de page (`@page size`) au format de l'étiquette → le pilote de
 *    l'imprimante thermique reçoit la bonne dimension de média ;
 *  - masque toute l'application à l'impression et n'affiche que les étiquettes ;
 *  - force un saut de page entre chaque étiquette.
 *
 * @param {{width:number,height:number}} format - dimensions en mm
 */
export function printLabels(format) {
    const css = `
        @page {
            size: ${format.width}mm ${format.height}mm;
            margin: 0;
        }
        @media print {
            body * { visibility: hidden !important; }
            #${PRINT_ROOT_ID}, #${PRINT_ROOT_ID} * {
                visibility: visible !important;
                color-adjust: exact !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
            }
            #${PRINT_ROOT_ID} {
                position: absolute !important;
                left: 0 !important;
                top: 0 !important;
                width: ${format.width}mm;
                margin: 0;
                padding: 0;
            }
            #${PRINT_ROOT_ID} .label-print-page {
                width: ${format.width}mm;
                height: ${format.height}mm;
                overflow: hidden;
                page-break-after: always;
                break-after: page;
            }
            #${PRINT_ROOT_ID} .label-print-page:last-child {
                page-break-after: auto;
                break-after: auto;
            }
        }
    `;

    let style = document.getElementById(STYLE_ID);
    if (!style) {
        style = document.createElement("style");
        style.id = STYLE_ID;
        document.head.appendChild(style);
    }
    style.textContent = css;

    window.print();
}
